import React from 'react';
import { IncidentMapSvg } from 'src/components/svg';

export const IncidentPin = () => {
	return <IncidentMapSvg />;
};
